<div style=" background-image: url('/assets/images/kittencorner.jpg'); background-position: 50% 60%; height: 400px;">
</div>
<div class="div-block-6">
  <div>
    <div class="w-row">
    <div class="column-22 w-col w-col-2a w-col-small-4 w-col-tiny-6">
      <div class="blocks pulse" (click)="gotoSearchByLifestage(8)" >
        <h3 class="heading-block pulse">Food</h3>
      </div>
    </div>
    <div class="column-21 w-col w-col-2a w-col-small-4 w-col-tiny-6">
      <div class="blocks pulse" routerLink="/store/products/9/cat-food.html">
        <h3 class="heading-block pulse">Treats</h3>
      </div>
    </div>


    <div class="column-19 w-col w-col-2a w-col-small-4 w-col-tiny-6">
      <div class="blocks pulse" routerLink="/store/products/11/cat-food.html">
        <h3 class="heading-block pulse">Supplies</h3>
      </div>
    </div>
    <div class="column-17 w-col w-col-2a w-col-small-4 w-col-tiny-6">
      <div class="blocks pulse"  routerLink="/store/products/10/cat-food.html" >
        <h3 class="heading-block pulse">Litters And Accessories</h3>
      </div>
    </div>
    <div class="column-20 w-col w-col-2a w-col-small-4 w-col-tiny-6">
      <div class="blocks pulse" routerLink="/blogs/category">
        <h3 class="heading-block pulse">Article</h3>
      </div>
    </div>
  </div>
  </div>

</div>

<div  class="col-12" text-center>
    <div  >
      <h3 class="heading-block pulse"> Have any Query related to your new Kitten? 
        Write to us at info@petcart.com.
        Our Team of Experts will get back to you.</h3>
    </div>
  </div>
